import Item from './Item';
import { ListStyled } from './List.style';
import { LoadingOverlay } from 'components/Basic/LoadingOverlay/LoadingOverlay';
import Webline from 'components/Layout/Webline/Webline';
import { RemoveFromCartHandler } from 'hooks/cart/useRemoveFromCart';
import { useCallback, useState } from 'react';
import { CartItemType } from 'types/cart';

type ListProps = {
    idSuffix?: string;
    items?: CartItemType[];
    removeItemFromCart: RemoveFromCartHandler;
    isRemovingItem: boolean;
};

const List: FC<ListProps> = ({ idSuffix, items, removeItemFromCart, isRemovingItem }) => {
    const [isAddToCartFetchingOnAnyProduct, setIsAddToCartFetchingOnAnyProduct] = useState(false);

    const removeItemHandler = useCallback<RemoveFromCartHandler>(
        (cartItem, listIndex, gtmListName) => removeItemFromCart(cartItem, listIndex, gtmListName),
        [removeItemFromCart],
    );

    if (items === undefined) {
        return null;
    }

    return (
        <Webline>
            <ListStyled>
                {isRemovingItem && <LoadingOverlay className="h-16 w-16" />}
                {items.map((item, index) => (
                    <Item
                        idSuffix={idSuffix}
                        key={item.uuid}
                        item={item}
                        listIndex={index}
                        onItemRemove={() => removeItemHandler(item, index, 'cart')}
                        isAddToCartFetchingOnAnyProduct={isAddToCartFetchingOnAnyProduct}
                        setIsAddToCartFetchingOnAnyProduct={setIsAddToCartFetchingOnAnyProduct}
                    />
                ))}
            </ListStyled>
        </Webline>
    );
};

export default List;
